import { Location } from "./user.definition";

// Base interface with common properties
interface BaseFacility {
  id: number;
  name: string;
  disabled?: boolean;
  contactEmail: string;
  facilityType: FacilityType;
  photoUrl: string;
  rating: number;
  reviews: number;
  location: Location;
  phoneNumber: string;
  website?: string | null;
  careTypes?: CareType[];
  insurance?: string[];
  isOpen: boolean;
  distance?: number;
  isPartner: boolean;
  specialties?: (string | { id?: string; code?: string; label?: string })[];
  healthcareFacilityServices: string[];
}
export type CareType = {
  id: number;
  label: string;
  code: string;
};

// Facility response from API (hours as object)
export interface FacilityResponse extends BaseFacility {
  hours: {
    [day: string]: {
      open: string;
      close: string;
    };
  };
}

// Facility request to API (hours as array)
export interface FacilityRequest extends Omit<BaseFacility, "id"> {
  careTypeIds?: number[];
  specialtyIds?: number[];
  hours: Array<{
    [day: string]: {
      open: string;
      close: string;
    };
  }>;
}

// Legacy Facility type - now aliased to FacilityResponse for backward compatibility
export type Facility = FacilityResponse;

export type Stats = {
  total: number;
  lastWeek: number;
  lastMonth: number;
  lastYear: number;
  weekChange: number;
  monthChange: number;
  yearChange: number;
};
export type HealthcareFacilityStats = {
  patientStatistics: Stats;
  doctorStatistics: Stats;
  appointmentStatistics: Stats;
};

export enum FacilityType {
  HOSPITAL = "HOSPITAL",
  CLINIC = "CLINIC",
  NURSING_HOME = "NURSING_HOME",
  RADIOLOGY_CENTER = "RADIOLOGY_CENTER",
  HEALTH_CENTRE = "HEALTH_CENTRE",
  EMERGENCY_SERVICES = "EMERGENCY_SERVICES",
  PHYSIOTHERAPY_CENTER = "PHYSIOTHERAPY_CENTER",
  HEALTH_POST = "HEALTH_POST",
  DENTIST = "DENTIST",
  PHARMACY = "PHARMACY",
  MEDICAL_OFFICE = "MEDICAL_OFFICE",
  LABORATORY = "LABORATORY",
  OTHER = "OTHER",
}

export const facilityStatsAction = {
  FETCH_FACILITY_STATS: "FETCH_FACILITY_STATS",
  FETCH_FACILITY_STATS_SUCCESS: "FETCH_FACILITY_STATS_SUCCESS",
  FETCH_FACILITY_STATS_FAILURE: "FETCH_FACILITY_STATS_FAILURE",
};

// Update payload type for facility updates (uses request format for hours)
export type FacilityUpdate = {
  name?: string;
  contactEmail?: string;
  phoneNumber?: string;
  website?: string | null;
  photoUrl?: string;
  location?: Location;
  specialtyIds?: (string | number)[]; // Array of specialty IDs (can be strings or numbers)
  services?: string[];
  insurance?: string[];
  facilityType?: FacilityType;
  careTypeIds?: number[];
  hours?: Array<{
    [day: string]: {
      open: string;
      close: string;
    };
  }>;
};
